export const sizes = [
  16, 32, 64, 96, 128, 256, 256, 256, 256, 384, 384, 384, 384, 640, 640, 640, 640, 640, 640, 640,
  640, 750, 750, 750, 828, 828, 1080, 1080, 1080, 1080, 1080, 1080, 1080, 1080, 1200, 1200, 1200,
  1200, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920,
  1920, 1920, 1920, 1920, 1920, 1920, 1920, 1920, 2048, 2048, 2048, 2048, 3840, 3840, 3840, 3840,
  3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840,
  3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840,
  3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840, 3840,
  3840, 3840, 3840, 3840,
];
